const translations = {
  fr: {
    radioAnalyticsConfiguration: {
      installingRadioAnalytics: `L’installation de RadioAnalytics se fait dynamiquement (au même style que Google Analytics).
                              Le script requiert l’instance du lecteur(s) pour déterminer si la radio est pausée ou non.
                              Collez l'extrait de code suivant dans la page contenant le lecteur pour installer RadioAnalytics.`,

      configuration: 'Configuration',
      configurationMarkdown: require('../content/radioAnalytics/fr/configuringRadioAnalytics.md'),
      verification: 'Vérification',
      verificationMarkdown: require('../content/radioAnalytics/fr/verifyingInstallation.md'),
      notes: 'Notes',
      notesMarkdown: require('../content/radioAnalytics/fr/installationNotes.md'),

      audioVideo: 'Audio & video',
      jwPlayer: 'JWPlayer',
      jPlayer: 'jPlayer',
      mediaElement: 'Media element',
      externalTracker: 'Traqueur externe',
      custom: 'Surmesure',
    },
  },
  en: {
    radioAnalyticsConfiguration: {
      installingRadioAnalytics: `Installing RadioAnalytics is done dynamically (similar to Google Analytics).
                                The script requires the instance of the player(s) in order to determine if the radio is paused or not.
                                Paste the following snippet in the page that contains the player to install RadioAnalytics. `,
      configuration: 'Configuration',
      configurationMarkdown: require('../content/radioAnalytics/en/configuringRadioAnalytics.md'),

      verification: 'Verification',
      verificationMarkdown: require('../content/radioAnalytics/en/verifyingInstallation.md'),

      notes: 'Notes',
      notesMarkdown: require('../content/radioAnalytics/en/installationNotes.md'),

      audioVideo: 'Audio & video',
      jwPlayer: 'JWPlayer',
      jPlayer: 'jPlayer',
      mediaElement: 'Media element',
      externalTracker: 'External tracker',
      custom: 'Custom',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/i18n/radioAnalyticsConfiguration.js